<template>
    <div :class="['news-feed', {slim: count <= 1}]">
        <div class="container" v-if="currentFeed">
            <span class="feed">
                <transition mode="out-in">
                    <Feed
                        :key="idx"
                        :feed="currentFeed"
                    />
                </transition>
            </span>
            <svg
                x="0px"
                y="0px"
                viewBox="0 0 44 44"
                v-if="count > 1"
            >
                <circle class="st0" cx="22" cy="22" r="20.5"/>
                <circle ref="thumb" class="st1" cx="22" cy="22" r="20.5"/>
            </svg>
        </div>
    </div>
</template>
<script>
import { fetchRSS } from '@/store/api/index'
import MixinSlidable from '@/components/MixinSlidable'
import Feed from '@/components/layout/Board/Feed'
import { TweenMax } from 'gsap'
export default {
    mixins: [MixinSlidable],
    components: {
        Feed
    },
    props: {
        layout: {
            type: String
        }
    },
    data() {
        return {
            animated: true,
            feeds: []
        }
    },
    computed: {
        count() {
            return this.feeds.length
        },
        currentFeed() {
            return this.feeds[this.idx]
        }
    },
    created() {
        fetchRSS(this.layout).then(res => {
            this.$set(this, 'feeds', res)
            this.$nextTick(this.changeFeed)
        })
    },
    beforeDestroy() {
        this.animated = false
    },
    methods: {
        changeFeed() {
            if(this.animated) {
                TweenMax.to(this.$refs.thumb, 10., {
                    strokeDashoffset: "+=152",
                    ease: Linear.easeNone,
                    onComplete: () => {
                        if(this.animated) {
                            this.next()
                            this.changeFeed()
                        }
                    }
                })
            }
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"

.news-feed
    font-size: 17px
    margin-left: 9.6%
    flex: 1
    @include media-breakpoint-down($lg)
        width: auto
        margin-right: 19.2%
        margin-left: 19.2%
        margin-top: 9.6%
        margin-bottom: 9.6%
    @media print
        display: none
.container
    max-width: 306px
    display: flex
    height: 208px
    flex-direction: column
    justify-content: flex-end
    margin-right: auto
    @include media-breakpoint-down($lg)
        max-width: initial
        height: auto
        margin: auto
    .slim &
        justify-content: center
.feed
    line-height: 1.5
svg
    width: 44px
    height: 44px
    display: block
    margin-top: 54px
.st0
    fill: none
    stroke: #E0E1E3
    stroke-width: 3
    stroke-miterlimit: 10
.st1
    fill: none
    stroke: #FF0000
    stroke-width: 3
    stroke-miterlimit: 10
    stroke-dasharray: 152
    stroke-dashoffset: -152
.feeded
    &.v-leave-active
        transition: opacity .625s
        /deep/ .caption
            transition: .625s ease, opacity .3s .325s
    &.v-leave-to
        /deep/ .caption
            transform: translateY(-100%) !important
            opacity: 0
</style>
